import BreadCrumb from './bread-crumb';
import BreadCrumbItem from './item';
import './styles/index.scss';
const ExportBreadCrumb = BreadCrumb;
ExportBreadCrumb.Item = BreadCrumbItem;
ExportBreadCrumb.displayName = 'BreadCrumb';
export default ExportBreadCrumb;
